angular.module('SpidApp')

.factory('CurrencyHistory', function () {
	var CurrencyHistory = function (params) {
		params = params || {}

		this.id      	= params.id
		this.agencyId	= params.agency_id
		this.currencyId	= params.currency_id
		this.rateOld 	= params.rate_old
		this.rateNew 	= params.rate_new
		
		if (params.updated_at) {
			this.updatedAt = new Date(params.updated_at).toISOString()
		}
	}

	return CurrencyHistory
})